import type { AlertingService } from '@application/AlertingService';

interface LoggingService {
  error: (...msg: Array<any>) => void;
  log: (...msg: Array<any>) => void;
}

export class LogAlertingService implements AlertingService {
  private loggingService: LoggingService;

  constructor(loggingService: LoggingService) {
    this.loggingService = loggingService;
  }

  reportError(error: Error, _extras?: any, _tags?: Record<string, string>) {
    this.loggingService.error(error.message);
  }

  reportMessage(message: string) {
    this.loggingService.error(message);
  }

  addBreadcrumb(message: string, data?: { [key: string]: any }) {
    this.loggingService.log(message, JSON.stringify(data));
  }
}
